import { ModuleWithProviders, NgModule } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { PartnerState, BankState } from './store';
import { ApiPartnerService, ApiPartnerMembershipSubscriptionService, ApiBankService } from './services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([ PartnerState, BankState ]),
  ],
  providers: [
    TransferState,
    ApiPartnerService,
    ApiPartnerMembershipSubscriptionService,
    ApiBankService,
    SnackbarService
  ]
})
export class PartnerDataAccessModule {

  static forRoot(environment: Environment): ModuleWithProviders<PartnerDataAccessModule> {
    return {
      ngModule: PartnerDataAccessModule,
      providers: [{ provide: APP_ENVIRONMENT, useValue: environment }]
    };
  }

}
